import React, { FC } from 'react'
import { Typography } from '@dg-shared'
import { useTranslate } from '../hooks/shared'
import { TRANSLATIONS as T } from '../constants'
import useContentStyles from '../pages/qb/Verify/Content/useContentStyles'
import { PolicyVerifyCardContentProps } from '../types'
import { getDataComponentName } from '@dg-util'

const PolicyVerifyCardContentContent: FC<PolicyVerifyCardContentProps> = ({ policy }) => {
  const { t } = useTranslate(`${T.OFFER_VERIFY}.card`)
  const { classes } = useContentStyles()
  const { DeductibleContents, CalculatedPrices, Address1, SumInsuredContents, Residents } = policy

  return (
    <div data-componentname={getDataComponentName(__filename)}>
      <Typography type='h3'>{t(`subtitle`)}</Typography>
      <Typography className={classes.cardDetails}>{t('Address1', { Address1 })}</Typography>
      <Typography className={classes.cardDetails}>
        {t('SumInsuredContents', { SumInsuredContents })}
      </Typography>
      <Typography className={classes.cardDetails}>
        {t('Alarm')}
        {policy.Alarm ? 'Ja' : 'Nei'}
      </Typography>
      <Typography className={classes.cardDetails}>
        {t('DeductibleContents', { DeductibleContents })}
      </Typography>
      <Typography className={classes.cardDetails}>{t('Residents', { Residents })}</Typography>

      <section className={`${classes.row} ${classes.spaceTop}`}>
        <Typography type='h3'>{t(`total`)}</Typography>
        <section className={classes.priceRow}>
          <Typography testId='total-price-content-no' type='h3' className={classes.priceText}>
            {`${CalculatedPrices.priceMonthly + CalculatedPrices.taxMonthly}`}
          </Typography>
          <Typography className={classes.currency}>
            {t('priceMonth', { priceMonthly: null })}
          </Typography>
        </section>
      </section>
      <Typography
        testId='verify-card-content-content-disclaimer'
        color='textDisclaimer'
        size='small'
      >
        {t('priceTotal', { priceTotal: policy.CalculatedPrices.priceTotal })}
      </Typography>
    </div>
  )
}

export default PolicyVerifyCardContentContent
